import { ItemKind } from '../../constants/ItemKind';
import { systemFolderId } from '../../constants/system-folder-id';
import { encodeItemId } from '../wix-site/parsers/item-id';
export const WIX_VIDEO_LIBRARY_LINK = 'wix-video-library-link';
export const wixVideoLibrary = siteToken => {
  return {
    id: encodeItemId(siteToken, WIX_VIDEO_LIBRARY_LINK),
    kind: ItemKind.Folder,
    source: 'wixSite',
    parentId: encodeItemId(siteToken, systemFolderId.SiteFiles),
    name: 'Video Library',
    createdAt: 0,
    updatedAt: 0,
    userId: null,
    tags: ['_wix_video_library']
  };
};